import { centerable as n } from "../decorators/centerable.js";
import { stylable as p } from "../decorators/stylable.js";
import { ALIGN_CLASSES_INVERSE as a } from "../../constants.js";
import { defineAttrs as o } from "../../utils/typed-attrs.js";
const i = o({
  type: { default: "paragraph" }
}), c = p(
  n({
    inline: !1,
    content: "inline*",
    group: "block",
    attrs: i,
    parseDOM: [
      {
        tag: "p",
        getAttrs(t) {
          let r;
          return t.parentElement && t.parentElement.classList.forEach((e) => {
            e in a && (r = a[e]);
          }), { alignment: r };
        }
      }
    ],
    toDOM() {
      return ["p", 0];
    }
  })
);
export {
  c as paragraphSpec
};
